import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { colors, inr } from "@/theme";
import { SectionTitle, Spinner, EmptyState } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

const STATUS_COLORS = {
  created: colors.warning, paid: colors.success, shipped: colors.info, delivered: colors.brandLight, cancelled: colors.error,
};

export function StatusPill({ status }) {
  return (
    <span style={{ background: STATUS_COLORS[status] || colors.surfaceTertiary, color: colors.onSurface, padding: "4px 12px", borderRadius: 999, fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>
      {status}
    </span>
  );
}

export default function Orders() {
  const [orders, setOrders] = useState(null);
  const isMobile = useIsMobile();
  useEffect(() => { api("/orders").then(setOrders).catch(() => setOrders([])); }, []);

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "24px 16px 40px" : "40px 24px 56px", maxWidth: 860 }}>
      <SectionTitle eyebrow="History" title="My Orders" />
      {orders === null ? <Spinner /> : orders.length === 0 ? (
        <EmptyState title="No orders yet" message="Your placed orders will appear here." action={<Link to="/" className="btn-primary" style={{ textDecoration: "none" }}>Start Shopping</Link>} />
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {orders.map((o) => (
            <Link key={o.id} to={`/order/${o.id}`} data-testid={`order-${o.id}`} style={{ textDecoration: "none", color: colors.onSurface, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 18, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }} className="card-hover">
              <div style={{ display: "flex", gap: 12, alignItems: "center", minWidth: 0 }}>
                {o.items?.[0]?.image && <img src={o.items[0].image} alt="" style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 8 }} />}
                <div style={{ minWidth: 0 }}>
                  <div className="font-body" style={{ fontWeight: 600 }}>#{o.id.slice(0, 8)}</div>
                  <div className="font-body clamp-1" style={{ fontSize: 13, color: colors.mutedText }}>{o.items?.map((i) => i.name).join(", ")}</div>
                  <div className="font-body" style={{ fontSize: 12, color: colors.mutedText, marginTop: 2 }}>{new Date(o.created_at).toLocaleDateString()}</div>
                </div>
              </div>
              <div style={{ textAlign: "right", flexShrink: 0 }}>
                <div className="font-body" style={{ fontWeight: 700, marginBottom: 6 }}>{inr(o.amount)}</div>
                <StatusPill status={o.status} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
